
import { makeStyles } from "@mui/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { M_TO_FT } from "../../helpers/conversionFactors";

const useStyles = makeStyles({
  root: {
    background: 'transparent',
    border: 0,
    color: 'text.primary',
    height: 'auto',
    width: '100%',
    // padding: '10px',
    overflow: 'hidden',
    // margin: 10
  },
  tableHeading: {
    marginLeft: 10,
    marginTop: 10,
  },
  table: {
    overflow: 'auto',
    minHeight: '100px',
    height: 700,
    marginTop: 30,
    marginBottom: 20,
  },
});

export const FBASurveyDataTable = ({ fbaSurveyData, units='metric' }) => {

  try {
    // STYLES
    const classes = useStyles();

    if (!fbaSurveyData || fbaSurveyData?.length === 0) return (<></>);

    const columns = [
      {
        field: 'md',
        headerName: `MD (${units === 'metric' ? 'm' : 'ft'})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: false,
        disableColumnMenu: true,
        type: 'number'
      },
      {
        field: 'tvd',
        headerName: `TVD (${units === 'metric' ? 'm' : 'ft'})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: false,
        disableColumnMenu: true,
        type: 'number'
      },
      {
        field: 'inc',
        headerName: 'Inclination (deg)',
        width: 150,
        editable: false,
        sortable: true,
        filterable: false,
        disableColumnMenu: true,
        type: 'number'
      }
    ];

    let rows = [];

    fbaSurveyData?.forEach((value, index) => {
      rows.push({
        id: index,
        md: units === 'metric' ? value?.md / M_TO_FT : value?.md, 
        inc: value?.inc,
        tvd: units === 'metric' ? value?.tvd / M_TO_FT : value?.tvd,
      });
    });

    return (
      <div className={classes.root}>
        <DataGrid
          rows={rows}
          columns={columns}
          rowsPerPageOptions={[10,25,50,100]}
          disableSelectionOnClick
          className={classes.table}
          components={{
            Toolbar: GridToolbar,
          }}
          style={{fontSize: 12}}
          density="compact"
        />
      </div>
    );
  } catch (error) {
    return <></>
  };
};
